import { render } from "./InquireHistory.vue?vue&type=template&id=51dde13c"
import script from "./InquireHistory.vue?vue&type=script&lang=js"
export * from "./InquireHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__